import map from "lodash/map"
import merge from "lodash/merge"
import keyBy from "lodash/keyBy"
import compact from "lodash/compact"
import head from "lodash/head"
import commonApiAuthRequest from "../apiAuthRequest"
import {
  COMPLECTATION_SERVICE_URL,
  MAPISSUES_CORE_URL,
  PASSPORT_REFERENCE_URL,
} from "./constants"

const CODE_OF_MTS_TYPE = `tmc_issues_oek`

const mtsFetch = mtsListId =>
  commonApiAuthRequest({
    url: `${COMPLECTATION_SERVICE_URL}/mts/${mtsListId}`,
    params: {},
  })

const materialFetch = nomenclature =>
  commonApiAuthRequest({
    url: `${PASSPORT_REFERENCE_URL}/objects/data/rowByKey/material/v1/${nomenclature}`,
    params: {},
  })

const mtsIssueTypeFetch = (codeOfMtsType = CODE_OF_MTS_TYPE) =>
  commonApiAuthRequest({
    url: `${MAPISSUES_CORE_URL}/issues/types`,
    params: {
      query: `code==${codeOfMtsType}`,
    },
  })

const linkedMtsIssuesFetch = (linkedIssues, idOfMtsType) =>
  commonApiAuthRequest({
    url: `${MAPISSUES_CORE_URL}/issues`,
    params: {
      query: `id=in=(${linkedIssues});typeId==${idOfMtsType}`,
    },
  })

const issueFetch = issueId =>
  commonApiAuthRequest({
    url: `${MAPISSUES_CORE_URL}/issues/${issueId}`,
    params: {},
  })

const getLinkedMtsIssues = async sourceIssueId => {
  const {
    data: { issueLinksFrom },
  } = await issueFetch(sourceIssueId)
  const linkedIssues = map(issueLinksFrom, `toIssueId`)
  const {
    data: [mtsIssueTypeInfo],
  } = await mtsIssueTypeFetch()
  const { id: idOfMtsType } = mtsIssueTypeInfo

  if (!linkedIssues || !idOfMtsType) {
    return undefined
  }

  const { data: linkedMtsIssues } = await linkedMtsIssuesFetch(
    linkedIssues,
    idOfMtsType,
  )

  return linkedMtsIssues
}

const findMtsListId = mtsIssues =>
  head(compact(map(mtsIssues, `customFields.tmc_list`)))

/**
 * makes request to get materials by issueId
 *
 * @param {number} tmcListId
 * @return {Array.<Object>} response - array of mts
 */
export const getMts = async sourceIssueId => {
  if (!sourceIssueId) {
    return undefined
  }

  const linkedMtsIssues = await getLinkedMtsIssues(sourceIssueId)

  if (!linkedMtsIssues) {
    return undefined
  }
  const mtsListId = findMtsListId(linkedMtsIssues)
  const {
    data: { mtsList },
  } = await mtsFetch(mtsListId)
  const nomenclatures = map(mtsList, `nomenclature`)
  const mtsResponse = await Promise.all(
    map(nomenclatures, payload => materialFetch(payload)),
  )
  const mtsInfo = map(mtsResponse, `data`)

  return merge(keyBy(mtsList, `nomenclature`), keyBy(mtsInfo, `code`))
}
